<!-- no selection, show something -->
@if (!(showTool || showFile || showJob)) {
  <div>
    <h3 class="panel-title">Selection</h3>
    <div class="chipster-highlight">
      <i>No file, tool or job selected</i>
    </div>
  </div>
}

<!-- tool -->
@if (showTool || settingsService.splitSelectionPanel$.getValue()) {
  <ch-tool-details [sessionData]="sessionData" [selectedDatasets]="selectionService.selectedDatasets"></ch-tool-details>
}

<!-- job -->
@if (showJob) {
  <ch-job [sessionData]="sessionData"></ch-job>
}

<!-- file -->
@if (showFile || settingsService.splitSelectionPanel$.getValue()) {
  <ch-selected-files
    [dataset]="selectionService.selectedDatasets[0]"
    [sessionData]="sessionData"
    [tools]="tools"></ch-selected-files>
}
